export function getDebouncePeriod(debouncePeriod: number = 500) {
	return process.env.NODE_ENV === "test" ? 1 : debouncePeriod;
}
